import { REQUEST_SAVE_CAMPAIGN, SAVE_CAMPAIGN_SUCCESS, SAVE_CAMPAIGN_ERROR } from './actionTypes';

export const requestSaveCampaign = () => ({ type: REQUEST_SAVE_CAMPAIGN });

export const saveCampaignSuccess = campaign => ({ type: SAVE_CAMPAIGN_SUCCESS, payload: campaign });

export const saveCampaignError = campaign => ({ type: SAVE_CAMPAIGN_ERROR, payload: campaign });
